import { useBreakpointContext } from 'EmailEditorUI/components/mo/BreakpointContext';
import { isHiddenForBreakpoint } from 'EmailEditorUI/utils/breakpointUtils';
import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ElementVisibilityContext = /*#__PURE__*/createContext({
  isParentHidden: false,
  isHidden: false
});
export function useElementVisibilityContext() {
  return useContext(ElementVisibilityContext);
}
export function ElementVisibilityContextProvider({
  children,
  styles
}) {
  const {
    breakpointName
  } = useBreakpointContext();
  const {
    isHidden: isParentHidden
  } = useElementVisibilityContext();
  const isHidden = isParentHidden || isHiddenForBreakpoint(breakpointName, styles);
  return /*#__PURE__*/_jsx(ElementVisibilityContext.Provider, {
    value: {
      isHidden,
      isParentHidden
    },
    children: children
  });
}